var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_409_17225)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0302 41.0227C37.8552 41.0052 37.6452 41.0052 37.4527 41.0227C33.2877 40.8827 29.9802 37.4702 29.9802 33.2702C29.9802 28.9827 33.4452 25.5002 37.7502 25.5002C42.0377 25.5002 45.5202 28.9827 45.5202 33.2702C45.5027 37.4702 42.1952 40.8827 38.0302 41.0227Z",
    stroke: "#0C3A2D",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7172 28.9998C54.1122 28.9998 56.8422 31.7473 56.8422 35.1248C56.8422 38.4323 54.2172 41.1273 50.9447 41.2498C50.8047 41.2323 50.6472 41.2323 50.4897 41.2498",
    stroke: "#0C3A2D",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2805 47.4798C25.0455 50.3148 25.0455 54.9348 29.2805 57.7523C34.093 60.9723 41.9855 60.9723 46.798 57.7523C51.033 54.9173 51.033 50.2973 46.798 47.4798C42.003 44.2773 34.1105 44.2773 29.2805 47.4798Z",
    stroke: "#0C3A2D",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0947 57.0002C55.3547 56.7377 56.5447 56.2302 57.5247 55.4777C60.2547 53.4302 60.2547 50.0527 57.5247 48.0052C56.5622 47.2702 55.3897 46.7802 54.1472 46.5002",
    stroke: "#0C3A2D",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_17225",
    x1: 74.55,
    y1: 0.00000214197,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77C23E",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFFF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboard);
export default __webpack_public_path__ + "static/media/user-dashboard.691c21000cf8460e8044f44312615bae.svg";
export { ForwardRef as ReactComponent };